// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1EfPo","addWidgetButton":"Header_addWidgetButton__3Nl8P","dashboardTabs":"Header_dashboardTabs__pMJDE","active":"Header_active__tdDf2"};